// composables
import useAuth from '../composables/useAuth'
import useSite from '../composables/useSite'
import useLoading from '../composables/useLoading'

// refs
import $user from '../state/$user'
import $auth from '../state/$auth'
import $site from '../state/$site'


const initGlobalState = async () => {
    const {startLoadingThis, stopLoadingThis} = useLoading()
    startLoadingThis()

    const auth = useAuth()
    $user.value = auth.$user
    $auth.value = auth.$auth

    const site = useSite(auth.$user)
    $site.value = site

    // everything depends on auth, so initialize separately
    await $auth.value.init()

    // init all other states
    await Promise.all([
        $site.value.init()
    ])

    stopLoadingThis()
}

export default initGlobalState